import { render, staticRenderFns } from "./RadialBarChart.vue?vue&type=template&id=b05f920e"
import script from "./RadialBarChart.vue?vue&type=script&lang=js"
export * from "./RadialBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports